import classnames from "classnames";
import Banner from "../../../components/common/Banner/Banner";
import BannerType from "../../../global/banner-type";
import banner_one from "../../../assets/images/banner_one.png";
import classes from "../../../styles/Home.module.scss";

function Introduction({ className }) {
  return (
    <div className={classnames(classes.bannerContainer, className)}>
      <Banner
        type={BannerType.SINGLE_IMAGE_BANNER}
        title="A solution for every business need. We have it all!"
        description=" If you’re looking for a one-stop-shop for all your marketing needs,
        Paytm has got you covered! With a wide range of services and features,
        this platform is designed to help businesses of every size and scale
        reach their target audience more effectively. Paytm offers a plethora of
        marketing tools that can help you build successful campaigns, manage
        your call centre, set up a loyalty program, and even streamline your
        HRMS."
        image={banner_one}
        maxWidth={610}
        headingnfontSize="2.5rem"
      />
    </div>
  );
}
export default Introduction;
